module.exports = __webpack_public_path__ + "img/thumbnail_SableAntelope_f_normal.9028c217.png";